import { gql } from '@api/gql';

export const GET_LOCATION = gql(/* GraphQL */`
  query FindLocation($searchBy: SearchByArgs) {
    getLocation(searchBy: $searchBy) {
      ...LocationsCoreFragment
    }
  }
`);


export const DOWNLOAD_CSV_LOCATION_PATIENTS_REPORT = gql(/* GraphQL */`
  query DownloadCSVLocationPatientsReport($searchBy: SearchByArgs, $pagination: PaginationArgs, $sort: SortingArgs, $options: QueryOptionsInputType) {
    downloadCSVLocationPatientsReport(searchBy: $searchBy, pagination: $pagination, sort: $sort, options: $options) { url }
  }
`);


export const GET_PAGINATED_LOCATION_PATIENTS = gql(/* GraphQL */`
  query GetPaginatedLocationPatients($searchBy: SearchByArgs, $pagination: PaginationArgs, $sort: SortingArgs, $options: QueryOptionsInputType) {
    getPaginatedLocationPatients(searchBy: $searchBy, pagination: $pagination, sort: $sort, options: $options) {
      __typename
      count
      currentPage
      totalPages
      rows {
        __typename
        status
        deleted_at
        location_id
        patient_id
        patient {
          patient_id
          user {
            __typename
            user_id
            identity {
              ...CynergyAccountCoreFragmentAlt
              addresses {
                __typename
                address_id
                room
                city
                state
                postal_code
                nickname
                type
                use
                display
                district
                lines {
                  line_id
                  line
                  order
                }
              }
            }
            demographics {
              ...DemographicsCoreFragmentAlt
            }
          }
        }
      }
    }
  }
`);

export const LOCATION_PATIENTS_FEED = gql(/* GraphQL */`
  query LocationPatientsFeed($searchBy: SearchByArgs, $pagination: PaginationArgs, $sort: SortingArgs, $options: QueryOptionsInputType) {
    locationPatientsFeed(searchBy: $searchBy, pagination: $pagination, sort: $sort, options: $options) {
      __typename
      count
      currentPage
      totalPages
      rows {
        __typename
        status
        location_id
        patient_id
        patient {
          __typename
          patient_id
          user {
            __typename
            user_id
            identity {
              ...CynergyAccountCoreFragmentAlt
            }
            demographics {
              ...DemographicsCoreFragmentAlt
            }
          }
        }
      }
    }
  }
`);

export const GET_ALL_LOCATION_PATIENTS = gql(/* GraphQL */`
  query GetAllLocationPatients($searchBy: SearchByArgs, $pagination: PaginationArgs, $sort: SortingArgs, $options: QueryOptionsInputType) {
    getAllLocationPatients(searchBy: $searchBy, pagination: $pagination, sort: $sort, options: $options) {
      location_id
      patient {
        user {
          __typename
          user_id
          cynergy_id
        }
      }
    }
  }
`);

export const GET_LOCATION_PATIENT = gql(/* GraphQL */`
  query GetLocationPatient($searchBy: SearchByArgs, $options: QueryOptionsInputType) {
    getLocationPatient(searchBy: $searchBy, options: $options) {
      __typename
      location_id
      patient_id
      patient {
        __typename
        patient_id
        user {
          __typename
          user_id
          identity {
            ...CynergyAccountCoreFragmentAlt

          }
          demographics {
            ...DemographicsCoreFragmentAlt
          }
        }

        medications {
          __typename
          usage_id
          practitioner_id
          usage_status: status
          notes
          adherence
          date_asserted
          category
          dosage_instruction
          administration_method
          administration_timing
          timing_display
          effective
          effective_period {
            __typename
            period_id
            start
            end
          }
          reason {
            __typename
            condition_id
            category
            body_site
            verification_status
            clinical_status
            severity
            note
            recorded_date
            abatement_date_string
            abatement_date_time
            onset_date_string
            onset_date_time
          }
          medication {
            __typename
            medication_id
            brand_name
            status
            code
            dose_form
            manufacturer
            detected_issues {
              __typename
              issue_id
              status
              category
              severity
              detail
              identified_at
              mitigation_action
              mitigation_date
              reference_uri
            }
            total_volume {
              __typename
              ratio_id
              numerator {
                __typename
                quantity_id
                value
                unit
                code
                system
              }
              denominator {
                __typename
                quantity_id
                value
                unit
                code
                system
              }
            }
          }
        }
      }
      location {
        __typename
        location_id
        alias
      }
      last_contact
      deleted_at
      status
    }
  }
`);

export const LOCATION_ADDRESSES = gql(/* GraphQL */`
  query GetLocationAddresses($searchBy: SearchByArgs, $sort: SortingArgs, $options: QueryOptionsInputType) {
    getLocationAddresses(searchBy: $searchBy, sort: $sort, options: $options) {
      __typename
      location_id
      address {
        ...AddressCoreFragment
      }
    }
  }
`);
